import { AUDIO_MESSAGE_PREFIX } from './constants.js';

const isAudioFiles = files => {
  if (!files || !files.length) {
    return false;
  }

  if (
    files.some(
      file =>
        file.mediaType.includes('audio') ||
        file.mediaType.includes('video/webm') ||
        file.mediaType.includes('video/mp4') ||
        file.mediaType.includes('audio/mpeg'),
    )
  ) {
    return (
      /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/.test(
        files[0].name,
      ) || files.some(file => file.name.startsWith(AUDIO_MESSAGE_PREFIX))
    );
  }

  return false;
};

export default isAudioFiles;
